import { mapActions } from 'vuex'

export default {
  created () {
    this.setCurrentOnboardingStep(this.$options.onboardingStep)
  },
  
  methods: {
    ...mapActions('onboarding', ['setCurrentOnboardingStep'])
  }
}
